import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import CAppTitle from '../../../app/components/CAppTitle';
import AdminInvestorsList from '../features/investors-list/AdminInvestorsList';
import langAdminInvestors from '../langs/langAdminInvestors';
import LAdmin from '../layouts/LAdmin';

const PAdminInvestors = () => {
	const { t } = useTranslation();
	return (
		<LAdmin>
			<Helmet>
				<title>IRP Admin tools - {t(langAdminInvestors.title.tag)}</title>
			</Helmet>
			<CAppTitle title={t(langAdminInvestors.title.tag)} id="title-admin-investors" />
			<AdminInvestorsList />
		</LAdmin>
	);
};

export default PAdminInvestors;
